import ArrowDownSimpleIcon from '@/public/static/icons/ArrowDownSimple.svg';
import BackIcon from '@/public/static/icons/Back.svg';
import BackArrowLeft from '@/public/static/icons/BackArrowLeft.svg';
import SvgBatteryChargeFillIcon from '@/public/static/icons/BatteryChargeFill.svg';
import BikeIcon from '@/public/static/icons/Bike.svg';
import CalendarNoteIcon from '@/public/static/icons/CalendarNote.svg';
import CarIcon from '@/public/static/icons/Car.svg';
import SvgCarSeatIcon from '@/public/static/icons/CarSeat.svg';
import Cash32Icon from '@/public/static/icons/Cash32.svg';
import ChevronDownIcon from '@/public/static/icons/ChevronDown.svg';
import ChevronRightIcon from '@/public/static/icons/ChevronRight.svg';
import ChevronRightGrayIcon from '@/public/static/icons/ChevronRightGray.svg';
import ChevronRightPrimaryIcon from '@/public/static/icons/ChevronRightPrimary.svg';
import CloseIcon from '@/public/static/icons/Close.svg';
import CurrentLocationIcon from '@/public/static/icons/CurrentLocation.svg';
import DownArrowPrimaryBgIcon from '@/public/static/icons/DownArrowPrimaryBg.svg';
import EditNoteIcon from '@/public/static/icons/EditNote.svg';
import ErrorVoucher from '@/public/static/icons/ErrorVoucher.svg';
import GPSIcon from '@/public/static/icons/GPS.svg';
import EmptyServiceModelsIcon from '@/public/static/icons/home/EmptyServiceModels.svg';
import HeroIcon from '@/public/static/icons/home/Hero.svg';
import HubIcon from '@/public/static/icons/Hub.svg';
import InfoPrimaryIcon from '@/public/static/icons/InfoPrimary.svg';
import InforIcon from '@/public/static/icons/information_circle.svg';
import InformationCircleIcon from '@/public/static/icons/InformationCircle.svg';
import LocationIcon from '@/public/static/icons/Location.svg';
import MyReservationIcon from '@/public/static/icons/MyReservation.svg';
import NoteIcon from '@/public/static/icons/Note.svg';
import CashIcon from '@/public/static/icons/payment/Cash.svg';
import MomoIcon from '@/public/static/icons/payment/Momo.svg';
import RefundIcon from '@/public/static/icons/payment/Refund.svg';
import WalletIcon from '@/public/static/icons/payment/Wallet.svg';
import PinIcon from '@/public/static/icons/Pin.svg';
import PointIcon from '@/public/static/icons/Point.svg';
import PointItemIcon from '@/public/static/icons/PointItem.svg';
import PromoDefaultIcon from '@/public/static/icons/PromoDefault.svg';
import EmptyRecordIcon from '@/public/static/icons/record/EmptyRecord.svg';
import RenterIcon from '@/public/static/icons/Renter.svg';
import SvgRoadBatteryIcon from '@/public/static/icons/RoadBattery.svg';
import SignOutIcon from '@/public/static/icons/SignOut.svg';
import SvgSpeedometerIcon from '@/public/static/icons/Speedometer.svg';
import SuccessVoucher from '@/public/static/icons/SuccessVoucher.svg';
import TooltipUpFrontFeeIcon from '@/public/static/icons/TooltipUpFrontFee.svg';
import UserIcon from '@/public/static/icons/User.svg';
import VoucherIcon from '@/public/static/icons/Voucher.svg';
import Voucher32Icon from '@/public/static/icons/Voucher32.svg';
import WarningIcon from '@/public/static/icons/Warning.svg';

export {
  ArrowDownSimpleIcon,
  BackIcon,
  CalendarNoteIcon,
  Cash32Icon,
  CashIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ChevronRightPrimaryIcon,
  ChevronRightGrayIcon,
  CurrentLocationIcon,
  EditNoteIcon,
  EmptyRecordIcon,
  EmptyServiceModelsIcon,
  GPSIcon,
  HeroIcon,
  HubIcon,
  InformationCircleIcon,
  LocationIcon,
  MyReservationIcon,
  PinIcon,
  PointIcon,
  PointItemIcon,
  RefundIcon,
  RenterIcon,
  SignOutIcon,
  UserIcon,
  Voucher32Icon,
  VoucherIcon,
  WalletIcon,
  ErrorVoucher,
  SuccessVoucher,
  CloseIcon,
  PromoDefaultIcon,
  WarningIcon,
  InforIcon,
  InfoPrimaryIcon,
  NoteIcon,
  MomoIcon,
  SvgBatteryChargeFillIcon,
  SvgCarSeatIcon,
  SvgRoadBatteryIcon,
  SvgSpeedometerIcon,
  BikeIcon,
  CarIcon,
  TooltipUpFrontFeeIcon,
  BackArrowLeft,
  DownArrowPrimaryBgIcon,
};
